


















































































































































































































































































































































































































import {
  computed,
  defineComponent,
  onMounted,
  reactive,
  ref,
  Ref,
  watch,
} from "@vue/composition-api";
import {
  AuthenticationApi,
  PromotionItemApi,
  FileType,
  FlyerAmount,
  PosterAmount,
  ProjectDto,
  SocialMediaFolderDto,
  SocialMediaApi,
  SocialMediaType,
} from "@/api";

import vueFilePond from "vue-filepond";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";

import { mapValidationErrors } from "@/util/Forms";

import {
  FilePondErrorDescription,
  FilePondFile,
  registerPlugin as filePondRegisterPlugin,
} from "filepond";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";
import i18n from "@/i18n";
import Store from "@/store";

const FilePond = vueFilePond();
filePondRegisterPlugin(FilePondPluginFileValidateType);
filePondRegisterPlugin(FilePondPluginFileValidateSize);

interface PromotionForm {
  errors: {};
  fields: {
    project: string | undefined | null;
    requesterName: string | undefined;
    address: string | undefined;
    city: string | undefined;
    postalCode: string | undefined;
    flyerAmount: FlyerAmount;
    posterAmount: PosterAmount;
    remarks: string | undefined;
  };
  isValid: boolean;
}

interface NarrowcastingForm {
  errors: {};
  fields: {
    height: string | undefined;
    width: string | undefined;
    fileType: string | undefined;
    logoGUID: string | undefined;
    sendFileTo: string | undefined;
    remarks: string | undefined;
  };
  isValid: boolean;
}

interface User {
  emailAddress: string | undefined;
  properties: {
    firstName: string | undefined;
    middleName: string | undefined;
    lastName: string | undefined;
  };
  fullName: string | undefined;
}

interface PosterCount {
  label: string;
  value: PosterAmount;
}

export default defineComponent({
  name: "PromotionMaterial",
  components: {
    FilePond,
  },
  setup(props, vm) {
    const socialMediaApi = new SocialMediaApi();
    const socialMediaFolders = ref<SocialMediaFolderDto[] | null>(null)
    const socialMediaPosterFolder = computed(() => {
      if (socialMediaFolders.value && socialMediaFolders.value[0]) {
        const posterDirectory = socialMediaFolders.value[0]
        return posterDirectory.files
      }
      return []
    })

    async function fetchSocialMediaImages() {
      const { data } = await socialMediaApi.socialMediaGetSocialMedia(SocialMediaType.EmployerPoster)
      socialMediaFolders.value = data
    }

    const api = new PromotionItemApi();

    const selectedProject = computed<ProjectDto | null>(
      () => Store.getters["User/getSelectedProject"]
    );

    const posters = ref<PosterCount[]>([
      {
        label: "geen",
        value: PosterAmount.AmountNone,
      },
      {
        label: "1",
        value: PosterAmount.Amount1,
      },
      {
        label: "2",
        value: PosterAmount.Amount2,
      },
      {
        label: "3",
        value: PosterAmount.Amount3,
      },
      {
        label: "4",
        value: PosterAmount.Amount4,
      },
      {
        label: "5",
        value: PosterAmount.Amount5,
      },
    ]);
    const fileOutput = ref<FileType[]>([
      FileType.Jpg,
      FileType.Png,
      FileType.Pdf,
    ]);
    const saving = ref(false);
    const user: Ref<User> = ref({
      emailAddress: "",
      properties: {
        FirstName: "",
        MiddleName: "",
        LastName: "",
      },
      fullName: "",
    });

    const promoForm: PromotionForm = reactive({
      errors: {},
      isValid: false,
      fields: {
        project: ref(""),
        requesterName: ref(""),
        address: ref(""),
        city: ref(""),
        postalCode: ref(""),
        flyerAmount: ref(FlyerAmount.Amount50),
        posterAmount: ref(PosterAmount.AmountNone),
        remarks: ref(""),
      },
    });

    const narrowForm: NarrowcastingForm = reactive({
      errors: {},
      isValid: false,
      fields: {
        height: ref(""),
        width: ref(""),
        fileType: ref(""),
        logoGUID: ref(""),
        sendFileTo: ref(""),
        remarks: ref(""),
      },
    });

    function handleUploadError(error: FilePondErrorDescription) {
      let snackbarError = i18n.t("promotion.logo-upload-error");
      if (error.code === 415 || error.code === 422) {
        snackbarError = i18n
          .t("generic.upload-unsupported-media-type")
          .toString();
      } else if (error.code === 413) {
        snackbarError = i18n.t("generic.upload-payload-too-large").toString();
      } else if (error.body) {
        snackbarError = error.body;
      }

      vm.root.$emit("snackbar", snackbarError, "error");
    }

    const filePond = ref({
      files: [],
      server: {
        url: process.env.VUE_APP_API,
        headers: {
          get Authorization() {
            return `bearer ${vm.root.$store.getters["Auth/getAuthorizationTokens"].accessToken}`;
          },
        },
        process: {
          url: "employerportal/Upload/Upload",
        },
        revert: {
          url: "employerportal/Upload/Delete",
          method: "POST",
        },
      },
      beforeAddFile: async () => {
        // Since we do not use Axios / TresPortalBaseAxiosHelper, we must ensure the tokens are still valid by forcing a refresh.
        const authApi = new AuthenticationApi();
        const tokens = vm.root.$store.getters["Auth/getAuthorizationTokens"];
        const { data } = await authApi.authenticationRefreshAccessToken(tokens);
        vm.root.$store.dispatch("Auth/refresh", data);
        return true;
      },
      processNarrowCast: (
        error: FilePondErrorDescription,
        file: FilePondFile
      ) => {
        if (error) {
          handleUploadError(error);
        } else {
          narrowForm.fields.logoGUID = file.serverId;
        }
      },
    });

    async function onSentPromotionItemsForm() {
      api
        .promotionItemSendPostersFlyersForm({
          project: promoForm.fields.project || "",
          requesterName: promoForm.fields.requesterName || "",
          address: promoForm.fields.address || "",
          postalCode: promoForm.fields.postalCode || "",
          city: promoForm.fields.city || "",
          flyerAmount: promoForm.fields.flyerAmount,
          posterAmount: promoForm.fields.posterAmount,
          remarks: promoForm.fields.remarks,
        })
        .then(() => {
          vm.root.$emit(
            "snackbar",
            i18n.t("promotion.promo-form-success").toString()
          );
        })
        .catch((err) => {
          vm.root.$emit(
            "snackbar",
            i18n.t("promotion.promo-form-failed").toString(),
            "error"
          );
          promoForm.errors = err.response.data.errors;
        });
    }

    async function onSentNarrowcastingForm() {
      await api
        .promotionItemSendNarrowcastForm({
          fileType:
            (narrowForm.fields.fileType as FileType) || fileOutput.value[0],
          fileId: narrowForm.fields.logoGUID || "",
          sendFileTo: narrowForm.fields.sendFileTo || "",
          height: parseInt(narrowForm.fields.height || "", 10) || 1080,
          width: parseInt(narrowForm.fields.width || "", 10) || 1920,
          remarks: narrowForm.fields.remarks,
        })
        .then(() => {
          vm.root.$emit(
            "snackbar",
            i18n.t("promotion.promo-form-success").toString()
          );
        })
        .catch((err) => {
          vm.root.$emit(
            "snackbar",
            i18n.t("promotion.narrowcast-form-failed").toString(),
            "error"
          );
          narrowForm.errors = err.response.data.errors;
        });
    }

    onMounted(() => {
      fetchSocialMediaImages()
      user.value = Store.getters["User/getUser"];
      let fullName = "";
      if (user.value.properties.firstName && user.value.properties.lastName) {
        fullName = `${user.value.properties.firstName} ${user.value.properties.lastName}`;
        if (user.value.properties.middleName) {
          fullName = `${user.value.properties.firstName} ${user.value.properties.middleName} ${user.value.properties.lastName}`;
        }
      }
      user.value = {
        ...user.value,
        fullName,
      };
      // Fill model values based on Store values
      // Promotion items form
      promoForm.fields.requesterName = user.value.fullName;
      promoForm.fields.project = selectedProject.value?.name;
      // Narrowcast form
      narrowForm.fields.sendFileTo = user.value.emailAddress;
    });

    watch(selectedProject, () => {
      promoForm.fields.project = selectedProject.value?.name;
    });

    return {
      socialMediaPosterFolder,
      filePond,
      fileOutput,
      posters,
      saving,
      onSentPromotionItemsForm,
      onSentNarrowcastingForm,
      promoForm,
      narrowForm,
      user,
      mapValidationErrors,
    };
  },
});
